<template>
  <div class="image-container" @mouseover="hovered = true"
			@mouseleave="hovered = false">
    <transition name="overlay">
        <div v-if="hovered" class="overlay" @click="$emit('clicked')">
            <div class="overlay-info d-flex align-items-center justify-content-center flex-column"> 
                <div class='overlay-info-title'>Werk #{{imageInfo.title}}</div>
                <div>{{imageInfo.size}} cm</div>
                <div>{{imageInfo.material}}</div>
                <div>{{imageInfo.sale}}</div>
            </div>
            <p class="h2 overlay-icon"><b-icon-zoom-in></b-icon-zoom-in></p>
        </div> 
    </transition>
    <image-loader :smallImageUrl="'gallery/' + imageInfo.smallUrl" :bigImageUrl="'gallery/' + imageInfo.url" class="gallery-image"> </image-loader>
  </div>
</template>

<script>
import { ImageInfo } from '../models/ImageInfo.ts';
import ImageLoader from './ImageLoader.vue';
import { BIcon, BIconZoomIn } from 'bootstrap-vue';

export default {
  name: 'GalleryItem',
  props: {'imageInfo': ImageInfo},
  components: {
      ImageLoader,
      BIconZoomIn
  },
  methods: {
    getImgUrl(picName) {
        return require('../assets/gallery/'+ picName);
    }
  },
  data() {
      return {
          hovered:false,
      };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .image-container{
        position:relative;
        width:100%;
        cursor: pointer;
    }

    .gallery-image {
        width:100%;
        height:100%;
    }
    
    .overlay {
        background: rgba(0,0,0, .6);
        display: flex;
        height: 100%;
        position: absolute;
        width: 100%;
    }

    .overlay-info{
        color:white;
        width: 100%;
        padding: 2rem;
        text-align: center;
    }

    .overlay-icon{
        color:#737373;
        position:absolute;
        bottom: 5%;
        right: 10%;
        margin-bottom:0;
    }
     .overlay-info-title{
         font-size:1.2rem;
         font-weight:500;
         padding-bottom: 1rem;
     }

    .overlay-info:hover {
        opacity:1;
    }

    .overlay-enter-active, .overlay-leave-active{
          transition: opacity 0.5s;
    }
    .overlay-enter, .overlay-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }   
</style>